module.exports = {"allPlans":"Ver todos os planos"}


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/MobileMenu/data.json
// module id = 1650
// module chunks = 0